import React from 'react';
import { withStyles, withTheme } from '@mui/styles';
import styles from './Synchronizable.styles';
import { availableGroups } from 'store/utils/knowledgeGraphOntologyIcons';
import SvgIcon from '@mui/material/SvgIcon';
import classNames from 'classnames';
import Tooltip from '@mui/material/Tooltip';
import { formatDuration } from 'studio/helpers';
import { vklTypes } from 'studio/pages/Editor/VklSyntaxHighlighter';
import Chip from 'studio/components/Chip/Chip';

export const getLabel = synchronizable =>
  synchronizable.vklQualifiedIdentifier?.replace(/^(kb\.)/, '') ||
  synchronizable.uri.substring(synchronizable.uri.indexOf('#') - 1);

const Synchronizable = ({ theme, classes, className, synchronizable, tooltipPlacement, ...props }) => {
  const Icon = synchronizable.vklType === vklTypes.class ? availableGroups['meta:KB_Class'].componentIcon : null;
  let status = null;
  let color;
  let backgroundColor = null;
  if (synchronizable.isSuccess === true) {
    status = 'success';
    color = theme.palette.common.white;
    backgroundColor = theme.palette.success.main;
  } else if (synchronizable.isSuccess === false) {
    status = 'failure';
    color = theme.palette.common.white;
    backgroundColor = theme.palette.error.main;
  } else if (synchronizable.isSuccess === null) {
    status = 'not synchronized';
  }

  return (
    <Tooltip
      title={
        <>
          <div>
            <b>Class</b> {getLabel(synchronizable)}
          </div>
          <table className={classes.tooltipTable} cellSpacing="0" cellPadding="0">
            <tbody>
              {synchronizable.syncPolicy && (
                <tr>
                  <td>Sync policy</td>
                  <td>{synchronizable.syncPolicy}</td>
                </tr>
              )}
              {status && (
                <tr>
                  <td>Status</td>
                  <td>{status}</td>
                </tr>
              )}
              {/* the duration only makes sense for synchronizable results, we omit it for synchronizables*/}
              {synchronizable.duration !== undefined && (
                <tr>
                  <td>Duration</td>
                  <td>
                    {/* the duration can be a number or the string "unknown", cf. usage in 'Synchronization' */}
                    {typeof synchronizable.duration === 'number'
                      ? formatDuration(synchronizable.duration)
                      : synchronizable.duration}
                  </td>
                </tr>
              )}
              {synchronizable.errorMessage && (
                <tr>
                  <td>Error message</td>
                  <td>{synchronizable.errorMessage}</td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      }
      placement={tooltipPlacement || 'top'}
      arrow
    >
      <Chip
        className={classNames(classes.root, className)}
        color={color}
        backgroundColor={backgroundColor}
        icon={Icon && <SvgIcon component={Icon} viewBox={Icon().props.viewBox} />}
        label={getLabel(synchronizable)}
        {...props}
      />
    </Tooltip>
  );
};

export default withTheme(withStyles(styles)(Synchronizable));
